var map = {
	"./aland-islands.svg": 97,
	"./albania.svg": 9079,
	"./algeria.svg": 2664,
	"./american-samoa.svg": 678,
	"./anguilla.svg": 5203,
	"./argentina.svg": 845,
	"./armenia.svg": 7289,
	"./australia.svg": 4583,
	"./austria.svg": 2438,
	"./azerbaijan.svg": 3241,
	"./bahrain.svg": 6102,
	"./belarus.svg": 269,
	"./belgium.svg": 6145,
	"./bolivia.svg": 5226,
	"./bosnia-and-herzegovina.svg": 1152,
	"./botswana.svg": 6025,
	"./brazil.svg": 8273,
	"./bulgaria.svg": 1906,
	"./cambodia.svg": 510,
	"./cameroon.svg": 295,
	"./canada.svg": 7942,
	"./chile.svg": 8536,
	"./china.svg": 1439,
	"./colombia.svg": 8383,
	"./costa-rica.svg": 6632,
	"./croatia.svg": 4441,
	"./cuba.svg": 6416,
	"./cyprus.svg": 9589,
	"./czech-republic.svg": 1493,
	"./denmark.svg": 9255,
	"./ecuador.svg": 8161,
	"./egypt.svg": 7581,
	"./estonia.svg": 9032,
	"./ethiopia.svg": 4019,
	"./finland.svg": 4534,
	"./france.svg": 2942,
	"./georgia.svg": 755,
	"./germany.svg": 393,
	"./greece.svg": 2675,
	"./haiti.svg": 3624,
	"./hong-kong.svg": 4781,
	"./hungary.svg": 1141,
	"./iceland.svg": 6484,
	"./india.svg": 8223,
	"./indonesia.svg": 3838,
	"./iran.svg": 9097,
	"./iraq.svg": 7493,
	"./ireland.svg": 8866,
	"./israel.svg": 1614,
	"./italy.svg": 6101,
	"./ivory-coast.svg": 6876,
	"./japan.svg": 6639,
	"./kazakhstan.svg": 3508,
	"./kuwait.svg": 8122,
	"./latvia.svg": 2295,
	"./liechtenstein.svg": 1789,
	"./lithuania.svg": 4635,
	"./luxembourg.svg": 8766,
	"./malaysia.svg": 181,
	"./mexico.svg": 5319,
	"./mongolia.svg": 8611,
	"./montenegro.svg": 4922,
	"./nauru.svg": 5091,
	"./netherlands.svg": 6535,
	"./nicaragua.svg": 3434,
	"./nigeria.svg": 2137,
	"./norway.svg": 1047,
	"./pakistan.svg": 7413,
	"./panama.svg": 1064,
	"./paraguay.svg": 5556,
	"./peru.svg": 6852,
	"./philippines.svg": 5526,
	"./portugal.svg": 4353,
	"./puerto-rico.svg": 9324,
	"./republic-of-macedonia.svg": 4099,
	"./republic-of-poland.svg": 831,
	"./romania.svg": 6082,
	"./russia.svg": 3474,
	"./serbia.svg": 6715,
	"./singapore.svg": 5976,
	"./slovakia.svg": 7583,
	"./slovenia.svg": 2889,
	"./south-africa.svg": 8263,
	"./south-korea.svg": 2138,
	"./spain.svg": 6498,
	"./sri-lanka.svg": 7309,
	"./sweden.svg": 6273,
	"./switzerland.svg": 7906,
	"./taiwan.svg": 6872,
	"./thailand.svg": 161,
	"./tunisia.svg": 2609,
	"./turkey.svg": 5114,
	"./ukraine.svg": 8733,
	"./united-arab-emirates.svg": 1217,
	"./united-kingdom.svg": 3462,
	"./united-states-of-america.svg": 6334,
	"./united-states.svg": 1520,
	"./uruguay.svg": 1545,
	"./venezuela.svg": 7550,
	"./vietnam.svg": 3901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7922;